import { useContext, useEffect, useRef } from "react";
import "./Checkbox.css";
import { FormContext } from "../../contexts/FormContext";
import Helper from "../../util/helper";
import { RenderScrollContext } from "../../contexts/RenderScrollContext";
import { useTranslation } from "react-i18next";

const { Form } = require("react-bootstrap");

export const Checkbox = ({ appearance, isAdvancedForm, componentData, onUpdateValue, isHorizontal }) => {
  const { title } = componentData;

  const titleValue = isAdvancedForm ? title.disableprintpdf ? '' : title.text : title;

  const { isHTML, checkDisabled, getScreenDimensions } = useContext(FormContext);
  const { calculateWidthPercentageOfPage, getPageWidth, getPageHeight } = useContext(RenderScrollContext);

  const isDisabled = checkDisabled(componentData);
  const hasError = componentData.error;
  const hideBorders = isAdvancedForm && componentData.hideborders;

  const isCheckbox = appearance === "checkbox";
  const isRadiobutton = appearance === "radiobutton";
  const { t } = useTranslation();

  const advancedCheckboxRef = useRef(null);

  const checkComponentSize = () => {
    if (!isAdvancedForm) return;

    const { width } = advancedCheckboxRef.current.getBoundingClientRect();
    const { height } = advancedCheckboxRef.current.getBoundingClientRect();

    const { page } = componentData.title.position;

    const percentage = calculateWidthPercentageOfPage(page - 1);

    const scaledWidth = width * (percentage / 100);
    const scaledHeight = height * (percentage / 100);

    advancedCheckboxRef.current.style.setProperty("width", `${scaledWidth}px`);
    advancedCheckboxRef.current.style.setProperty("height", `${scaledHeight}px`);
    advancedCheckboxRef.current.style.setProperty("min-width", `${scaledWidth}px`);
  }

  useEffect(() => {
    if (isDisabled) {
      onUpdateValue(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);

  useEffect(() => {
    checkComponentSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRadioButtonChange = (e) => {
    const value = e.target.id;

    onUpdateValue(value === "true");
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;

    onUpdateValue(checked);
  };

  const getPositionStyles = () => {
    const { fontFamily, fontSize } = getScreenDimensions();
    const { posx, posy, sizex, page } = componentData.title.position;

    const percentage = calculateWidthPercentageOfPage(page - 1);

    const pageWidth = getPageWidth(page - 1);
    const pageHeight = getPageHeight(page - 1);
    return Helper.getElementPositionStyles(posx, posy, sizex, fontFamily, '', pageWidth, pageHeight, percentage, isHorizontal, fontSize);
  }

  return (
      <div style={isAdvancedForm ? getPositionStyles() : {}} className={` ${isAdvancedForm ? 'advanced-form' : ''}  ${isDisabled ? 'disabled-container' : ''}  ${hasError ? (isAdvancedForm ? 'error-container-checkbox' : 'error-container') : ''} checkbox-container ${hideBorders? 'hide-checkbox-borders': ''}`}>
        {isRadiobutton && (
          <>
            {isHTML ? (
              <div
                dangerouslySetInnerHTML={Helper.mapInnerHtmlData(
                  titleValue
                )}
              />
            ) : (
              <label>{titleValue}</label>
            )}
            <Form className="inline-radio-buttons">
              <Form.Check
                type="radio"
                id="true"
                name="question-1"
                label={t('general.yes')}
                onChange={handleRadioButtonChange}
                checked={componentData.response}
                disabled={isDisabled}

              />
              <Form.Check
                type="radio"
                id="false"
                name="question-1"
                label={t('general.no')}
                checked={componentData.response === false}
                onChange={handleRadioButtonChange}
                disabled={isDisabled}
              />
            </Form>
          </>
        )}
        {isCheckbox && (
          <Form>
            <Form.Check type="checkbox">
              <Form.Check.Input ref={advancedCheckboxRef} type="checkbox" checked={componentData.response} onChange={handleCheckboxChange} disabled={isDisabled} />
              {isHTML ? (
                <div
                  dangerouslySetInnerHTML={Helper.mapInnerHtmlData(
                    titleValue
                  )}
                />
              ) : (
                <Form.Check.Label>{titleValue}</Form.Check.Label>
              )}
            </Form.Check>
          </Form>
        )}
      </div>
  );
};
